import { render, staticRenderFns } from "./tncComponent.vue?vue&type=template&id=7d6f596d"
import script from "./tncComponent.vue?vue&type=script&lang=js"
export * from "./tncComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports